"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = function _default(settings, callbackHandler) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    var firstName = (0, _get2["default"])(row, 'user.firstName');
    var lastInitial = (0, _get2["default"])(row, 'user.lastName').substring(0, 1);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-center text-nowrap ".concat(_style["default"].displayName, " ")
    }, "".concat(firstName, " ").concat(lastInitial, "."));
  };
};